// extracted by mini-css-extract-plugin
export default {"conditions":"RaffleConditions_conditions__V2+Ml","grid":"RaffleConditions_grid__PsoVY"};